import { ITrainingPersonRequirementsValues } from './training-person-requirements-form-types'
import {
  ITrainingPersonRequirement,
  ITrainingPersonRequirementsAddUpsert,
  ITrainingPersonRequirementUpdateUpsert,
  ITrainingPersonRequirementsBulkUpdateUpsert,
} from '../../../../interfaces'

export const trainingPersonRequirementToTrainingPersonRequirementsValues = (
  trainingPersonRequirement: ITrainingPersonRequirement | undefined,
): ITrainingPersonRequirementsValues | undefined => {
  if (!trainingPersonRequirement) {
    return undefined
  }

  return {
    personId: trainingPersonRequirement?.personId,
    effectiveStartDate: trainingPersonRequirement?.effectiveStartDate,
    effectiveEndDate: trainingPersonRequirement?.effectiveEndDate,
  }
}

export const trainingPersonRequirementsValuesToTrainingPersonRequirementsAddUpsert = (
  trainingPersonRequirementsValues: ITrainingPersonRequirementsValues,
): ITrainingPersonRequirementsAddUpsert | undefined => {
  if (!trainingPersonRequirementsValues || !trainingPersonRequirementsValues?.personId) {
    return undefined
  }

  return {
    personId: trainingPersonRequirementsValues?.personId,
    trainingTypeIds: trainingPersonRequirementsValues?.trainingTypeIds ?? [],
  }
}

export const trainingPersonRequirementValuesToTrainingPersonRequirementUpdateUpsert = (
  trainingPersonRequirementsValues: ITrainingPersonRequirementsValues,
  trainingPersonRequirement: ITrainingPersonRequirement,
): ITrainingPersonRequirementUpdateUpsert | undefined => {
  if (!trainingPersonRequirementsValues || !trainingPersonRequirement?.personId) {
    return undefined
  }

  return {
    id: trainingPersonRequirement.id,
    personId: trainingPersonRequirement.personId,
    effectiveStartDate: trainingPersonRequirementsValues?.effectiveStartDate,
    effectiveEndDate: trainingPersonRequirementsValues?.effectiveEndDate,
  }
}

export const trainingPersonRequirementsValuesToTrainingPersonRequirementsUpdateUpsert = (
  trainingPersonRequirementsValues: ITrainingPersonRequirementsValues,
  trainingRequirementIds: number[],
): ITrainingPersonRequirementsBulkUpdateUpsert | undefined => {
  if (!trainingPersonRequirementsValues || !trainingPersonRequirementsValues?.personId) {
    return undefined
  }
  
  return {
    requirementIds: trainingRequirementIds,
    personId: trainingPersonRequirementsValues.personId,
    effectiveStartDate: trainingPersonRequirementsValues?.effectiveStartDate,
    effectiveEndDate: trainingPersonRequirementsValues?.effectiveEndDate,
  }
}